import { themeTextColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { ReactNode } from 'react'
import { Fragment } from 'react'

export type HorizontalListProps = {
  className?: string
  divider?: ReactNode
  items: ReactNode[]
  prefix?: ReactNode
}

export const HorizontalList = ({
  className,
  divider,
  items,
  prefix,
}: HorizontalListProps) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 flex-wrap text-sm',
        themeTextColorMap.primary,
        className
      )}
    >
      {prefix}
      {items.map((item, index) => (
        <Fragment key={typeof item === 'string' ? item : `item-${index}`}>
          {typeof item === 'string' ? <span>{item}</span> : item}
          {index < items.length - 1 &&
            (divider ?? <span className={themeTextColorMap.secondary}>•</span>)}
        </Fragment>
      ))}
    </span>
  )
}
